"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./Header.module.css"));
function Header(props) {
    return (react_1.default.createElement("header", { className: styles.header },
        react_1.default.createElement("div", { className: styles.sectionHeader },
            react_1.default.createElement("img", { src: "/img/logo-asher.jpg", alt: "Asher-logo" }),
            react_1.default.createElement("h3", { className: "section-title " + styles.titlePosition }, props.title))));
}
exports.Header = Header;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvYXNoZXIvU3R1ZGVudFJlZmVycmFscy9wYXJ0cy9IZWFkZXIvSGVhZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxnREFBeUI7QUFDekIsMERBQTZDO0FBRTdDLFNBQWdCLE1BQU0sQ0FBQyxLQUFLO0lBQ3hCLE9BQU8sQ0FDSCwwQ0FBUSxTQUFTLEVBQUUsTUFBTSxDQUFDLE1BQU07UUFDNUIsdUNBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxhQUFhO1lBQ2hDLHVDQUFLLEdBQUcsRUFBQyxxQkFBcUIsRUFBQyxHQUFHLEVBQUMsWUFBWSxHQUFPO1lBQ3RELHNDQUFJLFNBQVMsRUFBRSxtQkFBaUIsTUFBTSxDQUFDLGFBQWUsSUFBRyxLQUFLLENBQUMsS0FBSyxDQUFNLENBQ3hFLENBQ0QsQ0FDWixDQUFBO0FBQ0wsQ0FBQztBQVRELHdCQVNDIn0=